import { UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT, type UpdateCustomer } from '@weft/types';
import { raiseUnreachable } from '@weft/utils';

export function buildSubmittedSectionData(updatedCustomer: UpdateCustomer): UpdateCustomer {
  switch (updatedCustomer.sectionToSubmit) {
    case UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.details:
      return {
        name: updatedCustomer.name,
        taxId: updatedCustomer.taxId,
        externalId: updatedCustomer.externalId,
        crmId: updatedCustomer.crmId,
        erpMetadata: updatedCustomer.erpMetadata,
        sectionToSubmit: UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.none,
      };
    case UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.address:
      return {
        address: updatedCustomer.address,
        sectionToSubmit: UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.none,
      };
    case UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.settings:
      return {
        settings: updatedCustomer.settings,
        sectionToSubmit: UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.none,
      };
    case UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.contacts:
      return {
        contacts: updatedCustomer.contacts,
        sectionToSubmit: UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.none,
      };
    case UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.none:
      return {
        sectionToSubmit: UPDATE_CUSTOMER_SECTIONS_TO_SUBMIT.none,
      };
    default:
      return raiseUnreachable(updatedCustomer.sectionToSubmit);
  }
}